import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Equipamento, Equipamentos } from 'app/interfaces/Equipamento';
import { CapitalizePipe } from "../../../pipes/capitalize/capitalize.pipe";
import { RemoverCaractersEspeciaisPipe } from "../../../pipes/remover-caracters-especiais/remover-caracters-especiais.pipe";
import { Operacao } from 'app/interfaces/Operacao';
import { LoadingComponent } from "../../loading/loading.component";
import { TempoPassadoTimestampPipe } from "../../../pipes/calcular-diferenca-tempo/calcular-diferenca-tempo.pipe";
import { DialogEncontrarEquipamentosComponent } from '../dialog-encontrar-equipamentos/dialog-encontrar-equipamentos';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-encontrar-equipamentos',
  standalone: true,
  imports: [CommonModule, CapitalizePipe, RemoverCaractersEspeciaisPipe, LoadingComponent, TempoPassadoTimestampPipe, DialogEncontrarEquipamentosComponent, TranslocoModule],
  templateUrl: './encontrar-equipamentos.component.html',
    styleUrl: './encontrar-equipamentos.component.css'
  })
  export class EncontrarEquipamentosComponent implements OnChanges {
  @Input() operacaoComEquipamentos!: Operacao;
  @Input({ required: true }) loading: boolean = false;
  @Output() geolocalizacaoSelecionada = new EventEmitter<number[]>();

  public equipamentosFiltrados: Equipamentos | null = null;
  public equipamentoSelecionado: number = -1;
  public mostrarDialogSemDados: boolean = false;
  public equipamentoSemDados: any = null;

  constructor(private translocoService: TranslocoService) {}

  public atualizarEquipamentoSelecionado(equipamento: any, geoloc: number[], indexEquipamento: number): void {
    if (equipamento.status_atual === 'sem-dados') {
      this.abrirDialogSemDados(equipamento);
      return;
    }

    this.equipamentoSelecionado = indexEquipamento;
    this.emitirGeolocalizacaoEquipamento(geoloc);
  }

  public abrirDialogSemDados(equipamento: any): void {
    this.equipamentoSemDados = equipamento;
    this.mostrarDialogSemDados = true;
  }
  public fecharDialog(): void {
    this.mostrarDialogSemDados = false;
    this.equipamentoSemDados = null;
  }

  public emitirGeolocalizacaoEquipamento(geoloc: number[]): void {
    this.geolocalizacaoSelecionada.emit(geoloc);
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['operacaoComEquipamentos']) {
      this.equipamentosFiltrados = this.operacaoComEquipamentos?.equipamentos ?? null;
    }
  }

  public filtrarEquipamentos(event: Event): void {
    const input = event.target as HTMLInputElement;
    const resultadoInput = input.value;
    this.equipamentosFiltrados = this.operacaoComEquipamentos.equipamentos!.filter((equipamento) => {
      let pesquisaPorOperador: boolean = equipamento.operador_atual ?
        equipamento.operador_atual?.vc_nome.toLowerCase().includes(resultadoInput.toLowerCase()) : false;
      return equipamento.vc_frota.toLowerCase().includes(resultadoInput.toLowerCase()) || pesquisaPorOperador;
    });
  }

  public temAlertaVelocidade(equipamento: Equipamento): boolean {
    return Boolean(
      equipamento.ultima_informacao_trator?.it_velocidade &&
      equipamento.ultima_informacao_trator.it_velocidade > 15
    );
  }

  public traduzStatus(status?: string, bl_ativo?: number): string {
    const t = (key: string) => this.translocoService.translate(key);

    if (!status) return t('COMPONENTS.MAPA.EQUIPMENT.statuses.no_data');
    if (bl_ativo === 0) return t('COMPONENTS.EQUIPAMENTOS.inactive');

    const value = status
      .toLowerCase()
      .replace(/[-_]/g, ' ')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();

    if (value.includes('trabal')) return t('COMPONENTS.MAPA.EQUIPMENT.statuses.working');
    if (value.includes('parado') && value.includes('just')) return t('COMPONENTS.MAPA.EQUIPMENT.statuses.justified_stop');
    if (value.includes('parado') && (value.includes('nao') || value.includes('nao'))) return t('COMPONENTS.MAPA.EQUIPMENT.statuses.unjustified_stop');
    if (value.includes('parado')) return t('COMPONENTS.MAPA.EQUIPMENT.statuses.stopped');
    if (value.includes('sinal')) return t('COMPONENTS.MAPA.EQUIPMENT.statuses.no_signal');
    if (value.includes('desconect')) return t('COMPONENTS.MAPA.EQUIPMENT.statuses.disconnected');
    if (value.includes('offline')) return t('COMPONENTS.MAPA.EQUIPMENT.statuses.offline');
    if (value.includes('plant')) return t('COMPONENTS.MAPA.EQUIPMENT.statuses.planting');
    if (value.includes('manobr')) return t('COMPONENTS.MAPA.EQUIPMENT.statuses.maneuvering');
    if (value.includes('desloc')) return t('COMPONENTS.MAPA.EQUIPMENT.statuses.displacement');
    if (value.includes('ativo')) return t('COMPONENTS.EQUIPAMENTOS.active');

    return value.charAt(0).toUpperCase() + value.slice(1);
  }
}